// extracted by mini-css-extract-plugin
export default {"resizable_popup":"DebugCC_resizable_popup__68n2K","scrollable_content":"DebugCC_scrollable_content__RBZkg"};